import moment from 'moment';
import { DATE_FORMAT } from 'Constants';

/**
 * Format date
 *
 * @param date
 * @returns {string}
 */
export function formatDate(date) {
    return moment(date).format(DATE_FORMAT);
}



// WEBPACK FOOTER //
// ./src/utils/formatDate.js